module.exports = __webpack_public_path__ + "static/media/BOT.d24d1ce3.png";